<shared-modal-container
  headline="Property added!"
  (closeModal)="close()"
  [isDialogPositionUp]="isDialogPositionUp">
  <div class="bg-light px-4 pb-4 w-100">
    <div class="text-center pb-4">
      Do you want to continue and add a mortgage for
      <b>{{ dynamicDialogConfig.data.propertyName }}</b
      >? This way, you can start tracking its status right away.
    </div>

    <div class="flex-column p-3 gap-3">
      <button
        type="submit"
        pButton
        class="m-a p-button p-button-primary centered w-100"
        (click)="addMortgage()">
        Yes, add mortgage
      </button>
      <button
        type="submit"
        pButton
        class="m-a p-button p-button-primary centered w-100"
        (click)="addNextProperty()">
        No, Add next property
      </button>
    </div>
  </div>
</shared-modal-container>
